import { useAuth } from "@/contexts/AuthContext";
import { canUseAssistant } from "@/lib/assistantAccess";
import { useManagerPermissions } from "@/hooks/useManagerPermissions";

/**
 * ¿Se le enseña el chat del Ulture Assistant a quien está dentro?
 *
 * Rol (admin/encargado, `canUseAssistant`) y, para el encargado, la sección
 * «Funciones avanzadas» (`advancedFeatures`) que el admin puede apagarle en
 * Ajustes → Equipo → Editar → Permisos. El servidor ya lo exige (ipm-ai-assistant
 * devuelve 403 `assistant_disabled`), así que la app no puede enseñar una puerta
 * que no abre — la misma regla que los peritos (A8 de la ficha asistente-ia).
 *
 * Mientras cargan los permisos se deja ver (como el resto de pantallas, que no
 * esconden nada por un fallo o un retraso de red): el servidor es la barrera.
 */
export function useCanUseAssistant(): boolean {
  const { role } = useAuth();
  const { permissions } = useManagerPermissions();
  if (!canUseAssistant(role)) return false;
  if (role === "manager" && permissions.advancedFeatures === false) return false;
  return true;
}
